(() => {
  document.addEventListener('smm:tierchange', (event) => {
    const root = event.target.closest?.('[data-smm-bundle]');
    const button = root?.querySelector('[data-smm-floating-reset]');
    if (!button) return;
    button.hidden = Number(event.detail?.tier || 1) === 1;
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-smm-floating-reset]');
    if (!button) return;
    const root = button.closest('[data-smm-bundle]');
    root?.dispatchEvent(new CustomEvent('smm:reset'));
  });
})();
